export const ENQUEUE_IN_APP_ALERT = 'ENQUEUE_IN_APP_ALERT';
export const REMOVE_IN_APP_ALERT = 'REMOVE_IN_APP_ALERT';
export const CLOSE_IN_APP_ALERT = 'CLOSE_IN_APP_ALERT';
export const CLEAR_IN_APP_ALERTS = 'CLEAR_IN_APP_ALERTS';
